const id_master_customer = {
    add: "tambah pelanggan",
    address: "alamat pelanggan",
    edit: "ubah pelanggan",
    email: "email pelanggan",
    name: "nama pelanggan",
    phone: "telepon pelanggan",
    upload: "unggah pelanggan",

    form: {
        ppn_label: "Aktifkan untuk menggunakan PPN",
        upload_title: "input data pelanggan",
        coa: "COA Piutang",
    },

    error: {
        create: "Gagal membuat pelanggan.",
        delete: "Gagal menghapus pelanggan.",
        edit: "Gagal mengubah pelanggan.",
    },

    success: {
        create: "Berhasil membuat pelanggan.",
        delete: "Berhasil menghapus pelanggan.",
        edit: "Berhasil mengubah pelanggan.",
    }
}

export default id_master_customer;